import APIClient from '@/shared/http/clients/api'

const resourceName = 'mesa-fila'
const APICore = process.env.APIBaseURLCore

const GetAll = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?inative=0&sort=nome,asc&size=500`, data, config)
const Create = (data) => APIClient.post(`${APICore}/${resourceName}/`, data)
const Update = (data, id) => APIClient.put(`${APICore}/${resourceName}/${id}`, data)
const GetById = (id) => APIClient.get(`${APICore}/${resourceName}/${id}`)
const GetByUsuario = (id) => APIClient.get(`${APICore}/${resourceName}/usuario-mesa/${id}`)

const MesaRepository = {
  GetAll,
  GetAllActive,
  Create,
  Update,
  GetById,
  GetByUsuario
}

export default MesaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/nxSenhas/mesa.js